import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { Compass } from 'lucide-react';
import { EmptyState } from '@/components/ui/EmptyState';

export function NotFound(): ReactElement {
  return (
    <main className="flex h-screen items-center justify-center">
      <EmptyState
        icon={<Compass className="h-12 w-12" aria-hidden="true" />}
        title="Página no encontrada"
        description="La ruta que buscas no existe."
        action={
          <Link to="/dashboard" className="text-primary-500 underline">
            Volver al inicio
          </Link>
        }
      />
    </main>
  );
}
